import { useEffect, useState } from "react";
import { OcultarDatosCss } from "../../../styles";
import { PopupFirma, PopupModal } from "../../../popup";
import Firma from "../contratoServicios/Firma";
import ContratoServicios from "../contratoServicios/ContratoServicios";
import { useHeader } from '../../../../context/HeaderContext';
import { Datos3Props, PaymentOption } from "@/types";
import { Link } from "react-router-dom";
import { ButtonClose } from "@/components/ui";

const Datos3: React.FC<Datos3Props> = ({
  isFirmaAccepted,
  onFirmaAccept,
  selectedProfesiones = [],
  paymentAmount,
  formData1,
  isEmpresa,
  hasErrorsDatos1,
  firmaBase64,
  contratoRef,
}) => {

  const { setHideHeader } = useHeader();

  const [isPrivacyAccepted, setIsPrivacyAccepted] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const [isCookiesAccepted, setIsCookiesAccepted] = useState(false);
  const [firmaPopupVisible, setFirmaPopupVisible] = useState(false);
  const [termsPopupVisible, setTermsPopupVisible] = useState(false);
  const [localErrors] = useState(false);
  const [isContratoVisible, setIsContratoVisible] = useState(false);
  const [paymentOption] = useState<PaymentOption>("Anual");
  const [firmaUrl, setFirmaUrl] = useState<string | null>(null);

  const formData2 = { selectedProfession: selectedProfesiones, payment: paymentAmount };
  const showBlur = localErrors || hasErrorsDatos1 || isFirmaAccepted;

  // Mostrar popup de firma cuando se aceptan las casillas
  useEffect(() => {
    if (isPrivacyAccepted && isTermsAccepted && isCookiesAccepted && !isFirmaAccepted) {
      openFirmaPopup();
    }
  }, [isPrivacyAccepted, isTermsAccepted, isCookiesAccepted, isFirmaAccepted]);

  // Generar PDF al aceptar firma
  useEffect(() => {
    if (isFirmaAccepted && contratoRef?.current) {
      contratoRef.current.generarPdfComoBase64()
        .then((base64) => base64 && sessionStorage.setItem("pdfContratoBase64", base64))
        .catch(err => console.error("Error generando PDF:", err));
    }
  }, [isFirmaAccepted, contratoRef]);

  useEffect(() => {
  if (isFirmaAccepted) {
    setIsPrivacyAccepted(true);
    setIsTermsAccepted(true);
    setIsCookiesAccepted(true);
  }
}, [isFirmaAccepted]);

  useEffect(() => {
    const closeHandler = () => {
      setFirmaPopupVisible(false);
      setTermsPopupVisible(false);
      setHideHeader(false);
    };

    window.addEventListener("closePopup", closeHandler);
    return () => window.removeEventListener("closePopup", closeHandler);
  }, []);


  // SOLO guarda el base64 y lo pasa hacia arriba
  const handleFirmaAccept = async (dataURL: string) => {
    onFirmaAccept?.(dataURL);   // Guardamos la firma en el estado global
    setFirmaUrl(dataURL);       // Opcional: para previsualizar

    // 🔥 Cerrar popup inmediatamente al firmar
    setFirmaPopupVisible(false);
    setHideHeader(false);

  };

  // Popup handlers
  const openFirmaPopup = () => { setHideHeader(true); setFirmaPopupVisible(true); };
  const closeFirmaPopup = () => {
    setHideHeader(false);
    setFirmaPopupVisible(false);

    // Si NO se firmó, limpiar los checkbox
    if (!isFirmaAccepted) {
      setIsPrivacyAccepted(false);
      setIsTermsAccepted(false);
      setIsCookiesAccepted(false);
    }
  };

  const openTermsPopup = () => { setHideHeader(true); setTermsPopupVisible(true); setIsContratoVisible(true); };
  const closeTermsPopup = () => { setHideHeader(false); setTermsPopupVisible(false); };
  useEffect(() => {
    if (isFirmaAccepted && firmaPopupVisible) {
      setFirmaPopupVisible(false);
      setHideHeader(false);
    }
  }, [isFirmaAccepted]);

  return (
    <div className={`${showBlur ? OcultarDatosCss.niebla : ""} xs:col-span-12 sm:col-span-12 md:col-span-4 px-3 py-1 space-y-3 rounded-md border dark:bg-white dark:text-zinc-700 border-zinc-600`}>
      <p className="font-semibold underline">He leído y acepto:</p>

      <CasillaDeVerificacion
        id="privacy-checkbox"
        label="Política de privacidad"
        to="/politicaPrivacidad"
        checked={isPrivacyAccepted}
        onChange={setIsPrivacyAccepted}
      />
      <CasillaDeVerificacion
        id="terms-checkbox"
        label="Contrato"
        to="#"
        onLinkClick={openTermsPopup}
        checked={isTermsAccepted}
        onChange={setIsTermsAccepted}
      />
      <CasillaDeVerificacion
        id="cookies-checkbox"
        label="Política de cookies"
        to="/politicaCookies"
        checked={isCookiesAccepted}
        onChange={setIsCookiesAccepted}
      />

      {/* Popup Firma */}
      {firmaPopupVisible && (
        <PopupFirma isOpen={firmaPopupVisible} onClose={closeFirmaPopup}>
          <div className="flex flex-col items-center space-y-4 p-4">
            <ButtonClose onClick={closeFirmaPopup} className="absolute top-3 right-3 text-zinc-700 hover:text-red-700 transition" />
            <h2 className="font-semibold text-xl">Firma el contrato</h2>
            <Firma
              onFirmaAccept={handleFirmaAccept}
              onSave={() => { }}
              onClose={closeFirmaPopup}
              onAccept={() => { }}
            />
            <p>¡Gracias por aceptar nuestros términos y condiciones!</p>
          </div>
        </PopupFirma>
      )}

      {/* Popup Términos */}
      {termsPopupVisible && (
        <PopupModal isOpen={termsPopupVisible} onClose={closeTermsPopup}>
          <div className="w-full overflow-y-auto flex-1 md:p-8">
            <h2 className="md:text-lg font-bold mb-2">Términos y condiciones</h2>
            {isContratoVisible && (
              <ContratoServicios
                ref={contratoRef}
                selectedProfesiones={selectedProfesiones}
                formData1={formData1}
                formData2={formData2}
                firmaBase64={firmaBase64}
                firmaUrl={firmaUrl}
                paymentMethod={paymentOption ?? ""}
                paymentOption={paymentOption}
                city="España"
                isEmpresa={isEmpresa ?? false}
                currentDate={new Date().toLocaleDateString()}
                numeroContrato={sessionStorage.getItem("numeroContrato") ?? ''}
              />
            )}
          </div>
        </PopupModal>
      )}
    </div>
  );
};

const CasillaDeVerificacion: React.FC<{
  id: string;
  label: string;
  to: string;
  onLinkClick?: () => void;
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ id, label, to, onLinkClick, checked, onChange }) => (
  <div className="flex items-center col-span-2">
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className={`
        w-5 h-5 my-2
        appearance-none
        border rounded cursor-pointer
        flex items-center justify-center
        ${!checked ? "checkbox-alert border-red-600" : "border-zinc-400"}
        checked:bg-blue-600
        checked:border-blue-600
        checked:before:content-["✓"]
        before:text-white
        before:flex before:items-center before:justify-center
      `}
    />

    <label
      htmlFor={id}
      className="ms-2 text-sm font-medium text-zinc-900 dark:text-zinc-300"
    >
      <Link
        to={to}
        onClick={(e) => {
          if (to === "#") {
            e.preventDefault();
            onLinkClick?.();
          }
        }}
        target={to !== "#" ? "_blank" : undefined}
        className="text-blue-600 underline"
      >
        {label}
      </Link>
    </label>
  </div>
);

export default Datos3;
